module.exports = __webpack_public_path__ + "img/partners11.20d39395.png";